import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1089d30c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Quote", -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_6 = ["value", "disabled"]
const _hoisted_7 = {
  key: 0,
  class: "form-field"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit", -1))
const _hoisted_9 = {
  key: 0,
  class: "form-field"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Select a unit", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Plan", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Custom Rate", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 3,
  class: "form-field"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Discount Plans", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No discount", -1))
const _hoisted_23 = {
  key: 0,
  value: null,
  disabled: ""
}
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Invoice Period", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "monthly",
  selected: ""
}, "Monthly", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "anniversary" }, "Anniversary", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Insurance", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Coverage", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = {
  key: 0,
  class: "text-center error"
}
const _hoisted_37 = {
  key: 1,
  class: "text-center error"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "col"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Generating Quote ")
const _hoisted_41 = {
  key: 1,
  class: "col"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Unit Name", -1))
const _hoisted_43 = {
  key: 0,
  class: "cost-section"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Due at Move-In", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "cost-note"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Amounts above are before tax.", -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Move In Subtotal", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Move In Taxes", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Move In Total", -1))
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "First Month Rent Subtotal", -1))
const _hoisted_54 = {
  key: 2,
  class: "cost-section"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Ongoing Monthly", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 3 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total Monthly Billing Amount", -1))
const _hoisted_59 = { id: "quote-options" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Disclaimer: Prices subject to change based on unit availability or other changes. ", -1))
const _hoisted_61 = { class: "row horizontal-center" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Print", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Create", -1))
const _hoisted_64 = /*#__PURE__*/_createTextVNode("New Customer")
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Fulfill this Quote", -1))

import { ref, watch, onMounted } from "vue";
import moment from "moment";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitTypeInterface } from "@/types/unit";
import {
  InvoiceableInterface,
  ServiceInterface,
  InvoiceItemInterface,
} from "@/types/customers";
import InvoicesFees from "./InvoicesFees.vue";

import { UnitInterface } from "@/types/unit";
// const router = useRouter();
// import Quote from "../Quote.vue";

import { useStore } from "../../store";
import { storeToRefs } from "pinia";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: false,
    default: null,
  },
  unitId: {
    type: String,
    required: false,
    default: null,
  },
  unitType: {
    type: String,
    required: false,
    default: null,
  },
  unitStatus: {
    type: String,
    required: false,
    default: "available",
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const isCcStorage = (userData.value.chosenFacility.api_name || "")
  .toLowerCase()
  .replace(/[-_ ]/g, "")
  .includes("ccstorage");

const status = ref("loading");
const amountRented = ref();
const unitTypes = ref(Array<UnitTypeInterface>());
const selectedUnitType = ref();
const selectedUnit = ref();
// const selectedTaxRate = ref();
// const selectedFeeTaxRate = ref();

const errors = ref("");
const customPrice = ref(false);
const formSubmitting = ref(false);
const customAmount = ref(null);
const insurances = ref();
// const selectedCustomer = ref();
const units = ref();
const filteredUnits = ref();
const quote = ref();

const feesAndProducts = ref(Array<InvoiceableInterface>());
const totalFeesProducts = ref(0);
const discountPlans = ref();

// const billingOptions = ref([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  move_in: {
    move_in_date: moment().format("YYYY-MM-DD"),
    unit_id: ref(),
    unit_type_id: ref(),
    invoice_period: "monthly",
    insurance_id: ref(null),
    services: ref(Array<ServiceInterface>()),

    invoiceable_items: ref(Array<InvoiceItemInterface>()),

    discount_plans: [
      {
        discount_plan_id: ref(null),
      },
    ],
  },
});

function selectFirstAvailableUnit() {
  if (!Array.isArray(filteredUnits.value) || !filteredUnits.value.length) {
    selectedUnit.value = null;
    formFields.value.move_in.unit_id = null;
    return;
  }
  selectedUnit.value = filteredUnits.value[0];
  updateForm();
}

onMounted(async () => {
  await getUnits();
  await getUnitTypes();

  status.value = "completed";
  if (props.unitId) {
    formFields.value.move_in.unit_id = props.unitId;
    let unit = units.value.filter(
      (item: UnitInterface) => item.id == props.unitId
    )[0];
    if (unit) {
      formFields.value.move_in.unit_type_id = unit.unit_type_id;
      selectedUnitType.value = unitTypes.value.filter(
        (item) => item.id == unit.unit_type_id
      )[0];
      selectedUnit.value = unit;
      await updateForm();
    }
  }

  await getInsurances();
  await getDiscountPlans();
});

async function getInsurances() {
  errors.value = "";
  const response = await api({
    url: `insurances/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body.invoiceable_items) {
      insurances.value = response.body.invoiceable_items;
    } else {
      insurances.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getDiscountPlans() {
  errors.value = "";
  let url = `discount_plans/?facilityId=${props.facilityId}`;
  if (api_settings.unit_id_with_discounts && selectedUnitType.value) {
    url += `&unitType=${selectedUnitType.value.id}`;
  }

  const response = await api({
    url: url,
  });
  if (response.status == 200) {
    if (response.body.discount_plans) {
      discountPlans.value = response.body.discount_plans;
    } else {
      discountPlans.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

watch(selectedUnitType, () => {
  if (units.value && props.unitStatus != "reserved") {
    filteredUnits.value = units.value.filter(
      (item: UnitInterface) => item.unit_group_id == selectedUnitType.value.id
    );
    if (!props.unitId) {
      selectFirstAvailableUnit();
    }
  }
  if (api_settings.unit_id_with_discounts) {
    getDiscountPlans();
  }
});
watch(amountRented, () => {
  if (amountRented.value == "custom") {
    customPrice.value = true;
  } else {
    customPrice.value = false;
  }
});

function updateFeesAndProducts(e: InvoiceableInterface) {
  if (e.service_id) {
    formFields.value.move_in.services.push({ service_id: e.service_id });
  } else {
    let item;
    if (api_settings.details_in_invoice) {
      item = {
        id: e.id,
        quantity: e.quantity,
        description: e.description,
        amount: e.amount,
      };
    } else {
      item = {
        id: e.id,
        quantity: e.quantity,
      };
    }
    formFields.value.move_in.invoiceable_items.push(item);
  }
  feesAndProducts.value.push(e);
  totalFeesProducts.value += Number(e.amount);
}
function removeFee(obj: InvoiceableInterface) {
  feesAndProducts.value.splice(
    feesAndProducts.value.indexOf(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      feesAndProducts.value.find((item) => item == obj)
    ),
    1
  );
  if (obj.service_id) {
    formFields.value.move_in.services.splice(
      formFields.value.move_in.services.indexOf(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        formFields.value.move_in.services.find(
          (item) => item.service_id == obj.service_id
        )
      ),
      1
    );
  } else if (obj.id) {
    formFields.value.move_in.invoiceable_items.splice(
      formFields.value.move_in.invoiceable_items.indexOf(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        formFields.value.move_in.invoiceable_items.find(
          (item) => item.id == obj.id
        )
      ),
      1
    );
  }
  if (totalFeesProducts.value) {
    totalFeesProducts.value -= Number(obj.amount);
  }
}
function print() {
  window.print();
}

async function getUnits() {
  let url = `units/?status=available&facilityId=${props.facilityId}`;

  if (props.unitStatus == "reserved") {
    url = `units/?id=${props.unitId}&facilityId=${props.facilityId}`;
  }

  errors.value = "";

  const response = await api({
    url,
  });

  if (response.status == 200) {
    if (props.unitStatus == "reserved") {
      units.value = response.body[0];
      filteredUnits.value = [units.value];
      selectedUnit.value = units.value;
    } else {
      units.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

function updateForm() {
  if (selectedUnitType.value) {
    amountRented.value = selectedUnitType.value.price;
  }
  if (selectedUnit.value) {
    formFields.value.move_in.unit_id = selectedUnit.value.id;
  }
}

async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
    if (api_settings.unit_counts) {
      unitTypes.value = unitTypes.value.filter(
        (item) => Number(item.available_units_count) > 0
      );
    }

    // await getTaxRates();
    selectedUnitType.value = unitTypes.value[0];
    updateForm();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  if (
    json.move_in.services.length == 0 ||
    (json.move_in.services.length == 1 && !json.move_in.services[0].service_id)
  ) {
    delete json.move_in.services;
  }
  if (
    json.move_in.invoiceable_items.length == 0 ||
    (json.move_in.invoiceable_items.length == 1 &&
      !json.move_in.invoiceable_items[0].id)
  ) {
    delete json.move_in.invoiceable_items;
  }
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `quote/?facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });

  formSubmitting.value = false;
  if ([200].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.move_in_unit_event) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      quote.value = responseData.body.move_in_unit_event;
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      quote.value = responseData.body;
    }
  } else if (responseData.status === 400) {
    formErrors.value = { server_error: [quoteErrorMessage(responseData.body)] };
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

function quoteErrorMessage(body: unknown) {
  if (!body || typeof body !== "object") {
    return "Unable to generate quote.";
  }
  const responseBody = body as {
    meta?: { message?: string };
    errors?: Array<{ field?: string; message?: string; code?: string }>;
    detail?: string;
    error?: string;
  };
  if (responseBody.meta?.message) {
    return responseBody.meta.message;
  }
  const firstError = responseBody.errors?.[0];
  if (firstError?.field && (firstError.message || firstError.code)) {
    return `${firstError.field}: ${firstError.message || firstError.code}`;
  }
  if (firstError?.message || firstError?.code) {
    return firstError.message || firstError.code || "Unable to generate quote.";
  }
  return (
    responseBody.detail || responseBody.error || "Unable to generate quote."
  );
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!quote.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "large-width-centered",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("fieldset", null, [
            (status.value === 'loading')
              ? (_openBlock(), _createBlock(BaseSpinner, {
                  key: 0,
                  preset: "large"
                }))
              : _createCommentVNode("", true),
            (status.value == 'completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUnitType).value = $event)),
                      required: "",
                      class: "form-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (typeOfUnit) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: typeOfUnit + 'id',
                          value: typeOfUnit,
                          disabled: __props.unitStatus == 'reserved'
                        }, _toDisplayString(typeOfUnit.size) + " " + _toDisplayString(typeOfUnit.description), 9, _hoisted_6))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedUnitType.value]
                    ])
                  ]),
                  (filteredUnits.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        (filteredUnits.value == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " No units available for this unit type. Reselect another unit type. "))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedUnit).value = $event)),
                          required: "",
                          class: "form-select",
                          disabled: __props.unitStatus == 'reserved',
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (updateForm()))
                        }, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUnits.value, (unit) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: unit + 'id',
                              value: unit
                            }, _toDisplayString(unit.name), 9, _hoisted_12))
                          }), 128))
                        ], 40, _hoisted_10), [
                          [_vModelSelect, selectedUnit.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedUnitType.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((amountRented).value = $event)),
                          class: "form-select",
                          required: ""
                        }, [
                          _createElementVNode("option", {
                            value: selectedUnitType.value.price
                          }, " $ " + _toDisplayString(selectedUnitType.value.price) + " per month ", 9, _hoisted_15)
                        ], 512), [
                          [_vModelSelect, amountRented.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (customPrice.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _hoisted_19,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customAmount).value = $event)),
                            type: "number",
                            step: ".01",
                            required: ""
                          }, null, 512), [
                            [_vModelText, customAmount.value]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (discountPlans.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.move_in.discount_plans[0].discount_plan_id) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_22,
                          (!discountPlans.value.length)
                            ? (_openBlock(), _createElementBlock("option", _hoisted_23, " No discounts available "))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discountPlans.value, (plan) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: plan.id + 'plan',
                              value: plan.id
                            }, _toDisplayString(plan.name), 9, _hoisted_24))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, formFields.value.move_in.discount_plans[0].discount_plan_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.move_in.invoice_period) = $event)),
                      class: "form-select"
                    }, _hoisted_29, 512), [
                      [_vModelSelect, formFields.value.move_in.invoice_period]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.move_in.insurance_id) = $event)),
                      class: "form-select"
                    }, [
                      _hoisted_32,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurances.value, (insurance) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: insurance.id,
                          value: insurance.id
                        }, _toDisplayString(insurance.description) + " - $" + _toDisplayString(insurance.amount) + " per month ", 9, _hoisted_33))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, formFields.value.move_in.insurance_id]
                    ])
                  ]),
                  _createVNode(InvoicesFees, {
                    "customer-id": __props.customerId,
                    "facility-id": __props.facilityId,
                    onFeesAndProducts: updateFeesAndProducts
                  }, null, 8, ["customer-id", "facility-id"]),
                  _createElementVNode("table", null, [
                    (feesAndProducts.value.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(feesAndProducts.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id + 'item'
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.description), 1),
                            _createElementVNode("td", null, "$" + _toDisplayString(item.amount), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (removeFee(item))
                              }, "remove", 8, _hoisted_34)
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            (formErrors.value.server_error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(formErrors.value.server_error[0]), 1))
              : _createCommentVNode("", true),
            (formErrors.value.non_field_errors)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(formErrors.value.non_field_errors[0]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              disabled: formSubmitting.value,
              type: "submit",
              class: "btn btn-text"
            }, [
              (formSubmitting.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(BaseSpinner)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, "Generate Quote"))
            ], 8, _hoisted_38)
          ])
        ], 40, _hoisted_2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.facilityId == _unref(userData).chosenFacility.id)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h3", null, _toDisplayString(_unref(userData).chosenFacility.facility_name), 1),
                _createElementVNode("h4", null, _toDisplayString(_unref(userData).chosenFacility.phone_number), 1)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("table", null, [
            (quote.value.invoice_line_items.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("tr", null, [
                    _hoisted_42,
                    _createElementVNode("td", null, _toDisplayString(quote.value.unit_name), 1)
                  ]),
                  (_unref(isCcStorage))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_43, _hoisted_45))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value.invoice_line_items, (line) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: line.id + 'item'
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(line.description) + " ", 1),
                        (line.discount && Number(line.discount) > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" with $" + _toDisplayString(Number(line.discount).toFixed(2)) + " discount ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, "$" + _toDisplayString(Number(line.total).toFixed(2)), 1)
                    ]))
                  }), 128)),
                  (_unref(isCcStorage) && Number(quote.value.move_in_taxes_total) > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_46, _hoisted_48))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _hoisted_49,
              _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.move_in_subtotal).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_50,
              _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.move_in_taxes_total).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_51,
              _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.move_in_total).toFixed(2)), 1)
            ]),
            (quote.value.first_month_rent_subtotal)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("td", null, "$" + _toDisplayString(quote.value.first_month_rent_subtotal), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(isCcStorage) && quote.value.total_monthly_billing_amount)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_54, _hoisted_56))
              : _createCommentVNode("", true),
            (quote.value.total_monthly_billing_amount)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.total_monthly_billing_amount).toFixed(2)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("fieldset", null, [
                _hoisted_62,
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (print()))
                }, "PDF")
              ]),
              _createElementVNode("fieldset", null, [
                _hoisted_63,
                _createVNode(_component_RouterLink, {
                  to: {
              name: 'customer_storedge',
              params: {
                rental: 'true',
                facilityId: __props.facilityId,
                customerId: null,
              },
            },
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_64
                  ]),
                  _: 1
                }, 8, ["to"]),
                _hoisted_65,
                _hoisted_66
              ])
            ])
          ])
        ], 64))
  ], 64))
}
}

})